import { render } from "./SubClusterForm.vue?vue&type=template&id=6cae50a6&ts=true"
import script from "./SubClusterForm.vue?vue&type=script&lang=ts"
export * from "./SubClusterForm.vue?vue&type=script&lang=ts"

import exportComponent from "/app/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__